const Form035EN = {
    stepName: {
        ImportantNotes: "Important Notes",
        ApplicationInfo: "Application Information",
        Confirmation: "Confirmation",
        SelectForm: "Declaration on Place of Residence",
        Documents: "Checklist of Supporting Documents",
    },
    label: {
        schoolType: {
            primary:
                "Native-speaking English Teacher (NET) Scheme in Primary Schools Declaration on Normal Place of Residence",
            secondary:
                "Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools Declaration on Normal Place of Residence",
        },
        schoolTypeTitle: "School Type",
        partA: "PART I (To be completed by the NET)",
        partB: "PART II (To be completed by the school)",
        partC: "{{school}} Supplementary Information",
        principal: "To: Supervisor/Principal of",
        school: "(School)",
        schoolName: "School",
        note: "I declare that",
        declareA: {
            a: "(a) I possess permanent resident status in",
            b: "(b) My social ties are outside Hong Kong.",
            c: "I have resided outside Hong Kong continuously for at least 5 years immediately before taking up an appointment under the NET Scheme in a {{school}} school in Hong Kong (if applicable).",
        },
        primary: "primary",
        secondary: "secondary",
        nameCountry: "(Name of country).",
        country: "Name of country",

        pForm: "NET-Form",
        sForm: "NET-Form",
        pForm1: "PNET-Form",
        singleType: "singleType",
        single: {
            single: "I am single.",
            married:
                "I am married and my spouse's particulars are provided as follows:",
        },
        netType: {
            new: "(a) For new NETs",
            serving: "(b) For serving NETs",
        },
        servingOption: {
            C: "I declare that my normal place of residence has been established outside Hong Kong. There are no changes on my personal or family particulars.",
            D: "I declare that my normal place of residence has been established outside Hong Kong. My updated personal or family particulars are provided in {{type}}-Form A and/or {{type}}-Form A (Annex) and supporting documents are attached.",
            E: "I declare that my normal place of residence has not been established outside Hong Kong. In support of the above claim of my normal place of residence outside Hong Kong, supplementary information is provided in {{type}}-Form A (Annex) and supporting documents are attached.",
        },

        fullName: "Full name of my spouse",
        idCard: "Hong Kong Identity Card Number (if any)",
        isNot: "I declare that my spouse of particulars stated above ",
        isNot1: "employed under the Enhanced NET Scheme in Secondary Schools or the NET Scheme in Primary Schools. If the answer is in the affirmative, please provide the employment details of your spouse as specified below:",
        isNotList: {
            Yes: "is",
            Not: "is not",
        },
        nameSchool: "Name of school",
        contract: "Contract period:",
        contractStart: "from",
        contractEnd: "to",
        from: "From",
        to: "To",
        declare: "declare",
        declarePrimary:
            "I declare that the above information is complete and correct. I confirm that I have read and understood the EDB {{number}} including the Notes for Completing {{form}} A-E. I understand that if I give any false or incorrect information, I shall render myself liable to disciplinary/legal proceedings and disqualification from receiving the fringe benefits provided under the NET Scheme in Primary Schools.",
        declareSecondary:
            "I declare that the above information is complete and correct. I confirm that I have read and understood the EDB {{number}} including the Notes for Completing {{form}} A-E. I understand that if I give any false or incorrect information, I shall render myself liable to disciplinary/legal proceedings and disqualification from receiving the fringe benefits provided under the Enhanced NET Scheme in Secondary Schools.",
        signatureOfNET: "Signature of NET",
        date: "Date",
        givenNames: "Full name of NET (Given names)",
        surname: "Full name of NET (Surname)",
        applyTitle: "Please Select",
        documents: "(To be completed by the NET and checked by the school)",
        document: "Checklist of supporting documents",
        confirm: "Confirm",
        note1: "Please note",

        netTypeLabel1:
            "I declare that my normal place of residence has not been established outside Hong Kong. In support of the above claim of my normal place of residence outside Hong Kong, supplementary information is provided in {{type}}-Form A (Annex) and supporting documents are attached.",
        netTypeLabel2:
            "I declare that my normal place of residence has been established outside Hong Kong. There are no changes on my personal or family particulars.",
        netTypeLabel3:
            "I declare that my normal place of residence has been established outside Hong Kong. My updated personal or family particulars are provided in {{type}}-Form A and/or {{type}}-Form A (Annex) and supporting documents are attached.",
    },
    partB: {
        partBTo: "To:",
        address1: "Secretary for Education",
        address2: "[Attn: NET Administration Team, Education Bureau]",
        address3: "Room W304, 3/F, West Block",
        address4: "Education Bureau Kowloon Tong Education Services Centre",
        address5: "19 Suffolk Road, Kowloon Tong, Kowloon",
        certify: "I certify that",
        fullName: "(Full name of the NET)",
        appointed: "is appointed under {{school}} in my school from",
        from: "from",
        to: "to",
        checked: "I have checked that the NET has:",
        completed: "(a) completed Part I and Annex of the {{formType}}; and",
        submitted:
            "(b) submitted the required supporting documents, if applicable, as listed in the attached checklist.",
        documents:
            "I have checked the documents provided by the NET in support of his/her declaration in Part I above and found the information correct. It is considered that:",
        residence: {
            a: "the NET's normal place of residence is outside Hong Kong. He/She is eligible to apply for the fringe benefits provided under {{school}} for appointees whose normal place of residence is outside Hong Kong. ",
            b: "the NET's normal place of residence is not outside Hong Kong. He/She is therefore not eligible for the fringe benefits provided under {{school}} for appointees whose normal place of residence is outside Hong Kong.",
        },
        info: "The application and copies of relevant documents certified by the school in support of the NET's application are forwarded herewith for your consideration.",
        primarySch: "the NET Scheme in Primary Schools",
        secondSch: "the Enhanced NET Scheme in Secondary Schools",
        supervisor: "Signature of supervisor/principal",
        date: "Date",
        principal: "Name of supervisor/principal",
        principalName: "Name of principal",
        supervisorName: "Name of supervisor",
        title: "Title of supervisor/principal",
        nameSchool: "Name of school",
        codeSchool: "School code",
        addressSchool: "School address",
        faxNo: "Fax no.",
        contactTitle: "Title of Contact person",
        contactName: "Contact person for enquiry",
        telNo: "Tel. no.",
        post: "Post of contact person",
        signatureList: {
            supervisor: "supervisor",
            schoolHead: "principal",
        },
        titleList: {
            "Mr.": "Mr.",
            "Mrs.": "Mrs.",
            "Ms.": "Ms.",
            "Miss.": "Miss.",
        },
        title1List: {
            "Mr.": "Mr.",
            "Mrs.": "Mrs.",
            "Ms.": "Ms.",
        },
    },
    // partC: {
    //     principal: "To: Supervisor/Principal of ____ (School)",
    //     fullName: "Re: ____(Full name of the NET)",
    //     schoolList: {
    //         a: "Native-speaking English Teacher (NET) Scheme in Primary Schools Declaration on Normal Place of Residence Supplementary Information",
    //         b: "Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools Declaration on Normal Place of Residence Supplementary Information",
    //     },
    // },
    secondary: {
        title: "Title of applicant",
        givenNames: "Full name of applicant (Given Names)",
        surName: "Full name of applicant (Surname)",
        birth: "Place of birth",
        nationality: "Nationality/Nationalities held",
        idCard: "Hong Kong Identity Card number (Mandatory to be provided once available)",
        isIdCard: "Holder of Hong Kong Permanent Identity Card",
        idCardList: {
            Yes: "Yes",
            No: "No",
        },
        spouse: "Full name of spouse",
        spouseTitle: "Title of Spouse",
        spouseList: {
            Mr: "Mr",
            Mrs: "Mrs",
            Ms: "Ms",
        },
        births: "Place of birth",
        nationalitys: "Nationality/Nationalities held",
        isIdCards: "Holder of Hong Kong Permanent Identity Card",
        outsideHk:
            "Residence <b>outside Hong Kong</b> since birth (in chronological order) (periods of excursion visits should be excluded)",
        outsideHkList: {
            from: "From (mm/yyyy)",
            to: "To (mm/yyyy)",
            place: "Place of residence",
            purpose: "Purpose",
        },
        inHk: "Period(s) of residence <b>in Hong Kong</b> since birth (in chronological order)",
        inHkList: {
            from: "From (mm/yyyy)",
            to: "To (mm/yyyy)",
            purpose: "Purpose",
            employment:
                "Purpose (Please provide the name of employer(s) in case of employment)",
        },
        children: "Particulars of children",
        childrenList: {
            name: "Full name",
            date: "Date of birth (dd/mm/yyyy)",
            place: "Place of birth",
        },
        detailsOfHouse:
            "Details of house(s), flat(s) or business owned, in Hong Kong or overseas, including address (documentary evidence of ownership must be produced)",
        ermsgName: "name",
        ermsgPlaceOfBirth: "place of birth",
        ermsgNationality: "nationality",
        ermsgAddress: "address",
        father: "Full name of father",
        fBirth: "His place of birth",
        fNationality: "His nationality",
        fAddress: "His present address",
        mother: "Full name of mother",
        mBirth: "Her place of birth",
        mNationality: "Her nationality",
        mAddress: "Her present address",
        detailsEm: "Details of parents' employment in Hong Kong, if any",
        fsName: "Full name of spouse's father",
        fsBirth: "His place of birth",
        fsNationality: "His nationality",
        fsAddress: "His present address",
        msName: "Full name of spouse's mother",
        msBirth: "Her place of birth",
        msNationality: "Her nationality",
        msAddress: "Her present address",
        brotherParticulars: "Particulars of brother(s)/sister(s)",
        brotherList: {
            name: "Full name",
            birth: "Place of birth",
            address: "Present address",
        },
        residing: "Particulars of close relative(s) residing in Hong Kong",
        residingList: {
            name: "Full name",
            relationship: "Relationship with you",
        },
        family: "If members of your family (e.g. parents, brothers, sisters) have emigrated overseas, please give details (documentary evidence must be produced, if required)",
        familyList: {
            relationship: "Relationship with you",
            date: "Date of emigration",
            country: "Country",
        },
        ermsgReason: "reason",
        ermsgInformation: "information",
        residence:
            "Where do you consider your normal place of residence? (Please give reasons if your normal place of residence is outside Hong Kong.)",
        reasons:
            "If you consider that your normal place of residence is outside Hong Kong, please give reasons for coming to Hong Kong",
        socialTies:
            "If you consider your social ties are in places other than Hong Kong, please give reasons",
        environment:
            "If you are employed on terms which do not provide for your periodically visiting or revisiting your normal place of residence, do you consider that such employment represents a material degree of dislocation or uprooting from the environment to which you belong? If the answer is in the affirmative, please give reasons",
        furtherInformation:
            "If you wish to provide further information about yourself and your family, please use the space below",
        understand:
            "I understand that if I wilfully give any false information or withhold any material information, I shall render myself liable to dismissal if I have been appointed to the post under {{school}}.",
        uSignature: "Signature of NET",
        uDate: "Date",
        uNames: "Full name of NET (Given names)",
        uSurname: "Full name of NET (Surname)",
    },
    notes: [
        {
            text: "For a NET to establish that his/her normal place of residence is outside Hong Kong, he/she should satisfy the criteria as set out in Part I of the application.",
        },
    ],
    reference: {
        title: "Reference Materials:",
        primaryText: "EDB {{number}} (NET Scheme in Primary Schools)",
        primaryLink: "{{primaryLink}}",
        secondaryText:
            "EDB {{number}} (Enhanced NET Scheme in Secondary Schools)",
        secondaryLink: "{{secondaryLink}}",
    },
    errorMsg: {
        conflict: "The date cannot overlap",
        code: "Please input the four-digit School code",
        fax: "Please input the eight-digit Fax no.",
    },
    table: {
        father: "Father",
        mother: "Mother",
        from: "From",
        to: "To",
        name: "Name and address of employer(s)",
    },
    document: [
        {
            text: "certified copy of passport or relevant documents to verify nationality of the NET, with relevant pages showing condition of stay in Hong Kong",
        },
        {
            text: "certified copy of passport or relevant documents to verify nationality of the NET's spouse, with relevant pages showing condition of stay in Hong Kong",
        },
        {
            text: "certified copies of documentary evidence to prove the NET's residence ",
        },
        {
            text: "outside Hong Kong",
        },
        {
            text: " as stated in this form, including:",
        },
        {
            text: "birth certificate of the NET and, if any, NET's unmarried children under the age of 18",
        },
        {
            text: "degree transcripts",
        },
        {
            text: "reference letters/graduation certificates from primary school/secondary school/college",
        },
        {
            text: "reference letters/certificates of service from previous employers",
        },
        {
            text: "employment records",
        },
        {
            text: "tenancy agreement",
        },
        {
            text: "rates/electricity bills",
        },
        {
            text: "marriage certificate (for married NET)",
        },
        {
            text: "others (Please specify _______________________________________)",
        },
        {
            text: "documentary evidence of ownership of house(s), flat(s) or business in Hong Kong or overseas as stated in this form",
        },
    ],
};
export default Form035EN;
